import {StyleRepository} from '@domain/model/Style/StyleRepository';
import {Segment} from '@lookiero/quiz';

const GetQuizSegment = (repository: StyleRepository): Promise<Segment> => repository.getQuizSegment();

export {GetQuizSegment};
